import { axiosInstance } from "./axiosInstance";

function getUserDegrees() {
    return axiosInstance.get('degrees/user');
}

function createDegree(data) {
    return axiosInstance.post('degrees', data);
}

function updateDegree(data) {
    return axiosInstance.put('degrees', data);
}

function deleteDegree(data) {
    return axiosInstance.delete('degrees', {params: data});
}

function showDegree(userId) {
    return axiosInstance.get(`degrees/show-degree${userId ? `?user_id=${userId}` : ''}`);
}

export {
    getUserDegrees,
    createDegree,
    updateDegree,
    deleteDegree,
    showDegree
}